import React, { FC, useState } from "react";
import { Avatar, Box, IconButton } from "@mui/material";

import { ChatConversation, Message } from "../../components/chat/chat";
import { AvatarLis } from "src/hooks/use-avatar-lis";
import { useAiAgentChatTracking } from "hooks";

export interface CategoryProps {
  messages: Message[];
  input: string;
  setInput: (input: string) => void;
  setMessages: (messages: Message) => void;
  loading: boolean;
  avatarLis: AvatarLis;
}

export const Chat: FC<CategoryProps> = ({
  messages,
  input,
  setInput,
  setMessages,
  loading = false,
  avatarLis,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { trackMessageSent, trackLinkClick } = useAiAgentChatTracking(isOpen);

  return (
    <div className="xvia-category">
      <Box
        sx={{
          position: "fixed",
          bottom: {
            xs: "8px",
            sm: "16px",
          },
          right: {
            xs: "0px",
            sm: "16px",
          },
          zIndex: 1000,
        }}
      >
        {isOpen ? (
          <ChatConversation
            input={input}
            messages={messages}
            setInput={setInput}
            setMessages={setMessages}
            loading={loading}
            setIsOpen={setIsOpen}
            avatarLisUrl={avatarLis.url}
            onMessageSent={trackMessageSent}
            onLinkClick={trackLinkClick}
          />
        ) : (
          <IconButton
            sx={{
              bgcolor: "#00384d",
              width: 64,
              height: 64,
              mr: {
                xs: "8px",
              },
            }}
            onClick={() => setIsOpen(true)}
          >
            <Avatar
              src={avatarLis?.url}
              alt={avatarLis?.description}
              sx={{ width: 64, height: 64 }}
            />
          </IconButton>
        )}
      </Box>
    </div>
  );
};
